import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IObjektArtsQueryShapes, ObjektArtsQueryFilterConfig } from 'fa-kt.types';
import { ObjektArtsService } from '../service';

@Component({
  selector: 'fa-kt-objekt-arts-filter',
  templateUrl: './objekt-arts-filter.component.html',
  styleUrls: ['./objekt-arts-filter.component.css'],
})
export class ObjektArtsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  ObjektArtsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objektArts: ObjektArtsService,
  ) {
    this.ObjektArtsFilterConfig = ObjektArtsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.objektArts.shapes$.subscribe((shapes: IObjektArtsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ObjektArtsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ObjektArtsFilterConfig[index].selections = shapes;
  }
}
